import { HomeOutlined } from "@ant-design/icons";
import { Breadcrumb as BC } from "antd";
import { Link } from "react-router-dom";

interface Props {
  pathText: string;
}

export const BreadcrumbComponent: React.FC<Props> = ({ pathText }) => {
  return (
    <BC
      items={[
        {
          title: (
            <Link to="/">
              <HomeOutlined />
            </Link>
          ),
        },
        {
          title: <Link to="/base-requirements">Requisitos</Link>,
        },
        {
          title: pathText,
        },
      ]}
    />
  );
};
